<mat-toolbar class="banner"
  role="banner"
  color="primary">
  <div class="container">
    <div class="row"
      [ngClass]="{'header-mobile': isMobile()}">
      <div class="col-6 col-md-10 d-flex flex-wrap align-items-center zone-logo-title">
        <a class="logo"
          tabindex="5"
          href="https://www.quebec.ca ">
          <img id="header-logo"
            alt="Logo"
            src="{{ headerLogo }}"
            width="199"
            height="60" />
        </a>

        <img id="header-logo-print"
          alt="Logo"
          src="{{ headerLogoPrint }}"
          width="199"
          height="60" />

        <a href="/"
          lang="fr"
          *ngIf="(isCarteLegere$ | async) === false"
          id="title-desktop"
          class="zone-title d-none d-md-block">
          {{ 'header.title' | translate }}
        </a>
        <span lang="fr"
          *ngIf="isCarteLegere$ | async"
          id="title-desktop"
          class="zone-title d-none d-md-block">
          {{ 'header.titlePublic' | translate }}
        </span>
      </div>

      <div class="col-6 col-md-2 d-flex justify-content-end zone-links">
        <ul class="nav flex-column">
          <!--<li><button class="buttonLanguage" disabled (click)="changeLanguage()">{{'header.language'}}</button></li>-->
          <li>
            <a *ngIf="(isCarteLegere$ | async) === false"
              rel="noopener noreferrer"
              alt="('header.contactUsUrl' | translate)"
              routerLink="/nous-joindre">
              {{ 'header.contactUs' | translate }}
            </a>
            <a *ngIf="isCarteLegere$ | async"
              rel="noopener noreferrer"
              alt="('header.contactUsUrl' | translate)"
              href="https://www.quebec.ca/gouvernement/ministeres-organismes/ressources-naturelles-forets/coordonnees-structure/generales">
              {{ 'header.contactUs' | translate }}
            </a>
          </li>
        </ul>
      </div>

      <div lang="fr"
        *ngIf="(isCarteLegere$ | async) === false"
        id="title-mobile"
        class="zone-title d-md-none col-12">
        <a>{{ 'header.title' | translate }}</a>
      </div>
      <div lang="fr"
        *ngIf="isCarteLegere$ | async"
        id="title-mobile"
        class="zone-title d-md-none col-12">
        {{ 'header.titlePublic' | translate }}
      </div>
    </div>
  </div>
</mat-toolbar>